import $ from 'jquery';
import { easepick } from '@easepick/core';
import { RangePlugin } from '@easepick/range-plugin';
import { LockPlugin } from '@easepick/lock-plugin';
import dateFormat from 'date-fns/format';

$('.js-easepick').each(function (index, element) {
  const picker = new easepick.create({
    element: element,
    css: [
      'https://cdn.jsdelivr.net/npm/@easepick/core@1.2.1/dist/index.css',
      'https://cdn.jsdelivr.net/npm/@easepick/range-plugin@1.2.1/dist/index.css',
      'https://cdn.jsdelivr.net/npm/@easepick/lock-plugin@1.2.1/dist/index.css',
      `${wordpress.template_directory_uri}/assets/css/easepick.css`,
    ],
    firstDay: 0,
    format: 'MMMM D, YYYY',
    plugins: [RangePlugin, LockPlugin],
    RangePlugin: {
      tooltip: false,
    },
    LockPlugin: {
      minDate: dateFormat(new Date(), 'yyyy-MM-dd'),
    },
    setup(picker) {
      // Bind the picker to the element so we can access the instance easily.
      $(element).data('picker', picker);
      picker.on('select', () => $(element).trigger('change'));
    },
  });
});
